<template>
    <div class="zt-page-content">
        <div v-if="!previewFlag && showImgs" style="overflow-y:auto;">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm1" label-width="120px">
                <div class="zt-block">
                    <div class="zt-block-head">基本信息</div>
                    <div class="zt-block-content">
                        <el-form-item label="商品名称" prop="name">
                            <el-input v-model="ruleForm.name" maxlength="30" placeholder="填写商品名称"></el-input>
                            <span class="font14-grey1" style="padding-left:10px;line-height:20px;position:relative;top:10px;"
                                >{{(ruleForm.name || '').length}}/30</span>
                        </el-form-item>
                        <el-form-item label="商品简称">
                            <el-input v-model="ruleForm.sname" maxlength="30" placeholder="填写商品简称"></el-input>
                            <span class="font14-grey1" style="padding-left:10px;line-height:20px;position:relative;top:10px;"
                                >{{(ruleForm.sname || '').length}}/30</span>
                        </el-form-item>
                        <!-- <el-form-item label="商品分类名称">
                            <div class="flex">
                                <div style="margin-right:32px;">
                                    <el-cascader :options="series" @change="handleCat" :show-all-levels="false" :props="{value:'id',label:'name',emitPath:false}"
                                        v-model="ruleForm.set_no" placeholder="请选择商品分类">
                                    </el-cascader>
                                </div>
                                <div>
                                    <router-link :to="{ path:'/desgin/txgl',query:{idx:price_type} }" target="_blank">
                                        <el-button type="primary" plain>新建商品分类</el-button>
                                    </router-link>
                                </div>
                            </div>
                        </el-form-item> -->
                        <el-form-item label="单品风格" prop="style_no">
                            <el-select v-model="ruleForm.style_no" placeholder="请选择风格">
                                <el-option v-for="item in styles" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品描述">
                            <el-input v-model="ruleForm.intro" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="单品类目" prop="cat_id">
                            <el-cascader :options="cats" :disabled="product_no&&catId?true:false" @change="handleCat" :show-all-levels="false" :props="{value:'id',label:'name',emitPath:false}"
                                v-model="ruleForm.cat_id" placeholder="请选择类目">
                            </el-cascader>
                        </el-form-item>
                        <div v-if="ruleForm.attr && ruleForm.attr.length>0 && ruleForm.attr[0].id">
                            <el-form-item class="block-bg" :style="(idx+1)==ruleForm.attr.length ? 'margin-bottom:0;' : ''"
                                v-for="(attr,idx) in ruleForm.attr" :key=idx 
                                :prop="attr.nullable ? ('attr.' + idx + '.values') : ''"
                                :rules="attr.nullable ? rules.attr : []"
                                :label="attr.name">
                                <div v-if="attr.type=='single' && attr.items && attr.items.length>0">
                                    <el-select v-model="attr.values" placeholder="请选择">
                                        <el-option v-for="item in attr.items" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                                <div v-if="attr.type=='mutil' && attr.items && attr.items.length>0">
                                    <el-checkbox-group v-model="attr.values">
                                        <el-checkbox v-for="item in attr.items" :key="item.id" :label="item.id" :value="item.id">{{item.value}}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="zt-block">
                    <div class="zt-block-head">设计信息</div>
                    <div class="zt-block-content">
                        <el-form-item label="设计尺寸">
                            <DesignSize v-model="ruleForm.dimension"></DesignSize>
                        </el-form-item>
                        <el-form-item style="padding-top:10px;" label="设计理念">
                            <div style="position:relative;max-width:500px;">
                                <el-input type="textarea" v-model="ruleForm.design_idea" maxlength="120" rows="5" style="max-width:500px;"></el-input>
                                <div class="font14-grey1" style="position:absolute;right:10px;bottom:6px;">{{(ruleForm.design_idea || '').length}}/120</div>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="zt-block">
                    <div class="zt-block-head">图片与视频</div>
                    <div class="zt-block-content">
                        <el-form-item label="3D 单品渲染图" prop="photo_render">
                            <div>
                                <UploadImgs v-if="showImgs" :limit="5" v-model="ruleForm.photo_render" prefix='product/render'></UploadImgs>
                            </div>
                        </el-form-item>
                        <el-form-item label="标高图">
                            <div>
                                <UploadImgss v-if="showImgs" v-model="ruleForm.photo_size" :limit="10" prefix='product/size'></UploadImgss>
                            </div>
                        </el-form-item>
                        <el-form-item label="素材图" style="margin-bottom:0px;">
                            <div>
                                <UploadImgss v-if="showImgs" v-model="ruleForm.photo_story" :limit="10" prefix='product/story'></UploadImgss>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="zt-block">
                    <div class="zt-block-head">文件</div>
                    <div class="zt-block-content">
                        <el-form-item label="设计CAD文件：" style="margin-bottom:0;">
                            <div style="position:relative;">
                                <UploadCads v-if="showImgs" v-model="ruleForm.photo_cad" prefix='product/cad'></UploadCads>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="zt-block">
                    <div class="zt-block-head" v-if="ruleForm.accessory && ruleForm.accessory.length>0">附件信息</div>
                    <div class="zt-block-content" v-if="ruleForm.accessory && ruleForm.accessory.length>0" style="padding:0 30px;">
                        <div class="list-item" v-for="(item,idx) in ruleForm.accessory" :key="idx">
                            <div style="position:absolute;top:30px;right:0;z-index:999;" class="flex flex-align-center">
                                <div style="font-size:16px;color:#292929;line-height:42px;margin-right:10px">附件{{idx+1}} </div>
                                <div v-if="item.id">
                                    <el-button v-if="item.stat==3" @click="changeSwitch(item,idx)" size="mini" type="primary" plain>启用</el-button>
                                    <el-button v-if="item.stat==2" @click="changeSwitch(item,idx)" size="mini" type="primary" plain>禁用</el-button>
                                </div>
                                <el-button v-else @click="delAccessory(idx)" style="font-size:14px;color:#FF4D4F;" type="text">
                                    <i class="iconfont icon-icon7"></i> 删除
                                </el-button>
                            </div>
                            <el-form-item label="附件名称" :prop="'accessory.'+ idx +'.name'" :rules="rules.accessoryName">
                                <el-input v-model="item.name" placeholder="请填写附件名称"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="型号" :prop="'accessory.'+ idx +'.module_no'" :rules="rules.accessoryModuleNo">
                                <el-input v-model="item.module_no" placeholder="请填写型号"></el-input>
                            </el-form-item> -->
                            <el-form-item label="设计尺寸">
                                <DesignSize v-model="item.dimension"></DesignSize>
                            </el-form-item>
                            <el-form-item label="标高图">
                                <div>
                                    <UploadImgss v-if="showImgs" v-model="item.photo_size" :limit="10" prefix='product/size'></UploadImgss>
                                </div>
                            </el-form-item>
                            <el-form-item label="素材图" style="margin-bottom:0px;">
                                <div>
                                    <UploadImgss v-if="showImgs" v-model="item.photo_story" :limit="10" prefix='product/story'></UploadImgss>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="add-accessory flex flex-align-center flex-pack-center">
                        <div @click="addAccessory()" class="addSeries">
                            <span>+</span>
                            <span>点击添加附件</span>
                        </div>
                    </div>
                </div>
                <!-- <div @click="addStyle()" class="zt-block addSeries">
                    <span>+</span>
                    <span>点击添加附件</span>
                </div> -->
                <div class="zt-block">
                    <div class="zt-block-head">销售信息</div>
                    <div class="zt-block-content">
                        <el-form-item class="input-red" style="margin-bottom:20px;" prop="price_percent" label-width="0px">
                            <div style="position:relative;left:0;" class="flex flex-align-center">
                                <div style="font-size:24px;color:#F66F6A;margin-right:10px;">分成比例：按销售额每单</div>
                                <div style="margin-right:10px;">
                                    <el-input style="width:80px;" type="number" v-model="ruleForm.price_percent" min="0"></el-input>
                                </div>
                                <div style="font-size:24px;color:#F66F6A;">%</div>
                            </div>
                        </el-form-item>
                        <div class="ruleDesc">
                            <div class="font14-grey" style="margin-bottom:10px"><b>签单规则</b></div>
                            <div>
                                <p>1.上架的设计提交后，该作品会在设计超市中展示，工厂可查看并购买。</p>
                                <p>2.每个作品最多能被10家工厂同时合作。</p>
                                <p>3.按销售额每单分成后，工厂卖出一件商品，设计师都可以获得分成，可在“设计管理”中查看。</p>
                                <p>4.选择已屏蔽的工厂后，该工厂无法看到本作品。</p>
                            </div>
                        </div>

                        <div style="max-width:400px;margin:50px auto 0;">
                            <div v-if="product_no" class="flex flex-justify-around">
                                <el-button @click="preview()" size="small" type="text">
                                    <i style="font-size:14px;position:relative;top:1px;margin-right:5px;" class="iconfont icon-sousuo"></i>
                                    <span>上架预览</span>
                                </el-button>
                                <el-button size="small" type="primary" @click="back()">取消</el-button>
                                <el-button size="small" type="primary" @click="editSubmit(0)">保存</el-button>
                                <el-button size="small" @click="editSubmit(1)" type="primary">上 传</el-button>
                            </div>
                            <div v-else class="flex flex-justify-around">
                                <el-button @click="preview()" size="small" type="text">
                                    <i style="font-size:14px;position:relative;top:1px;margin-right:5px;" class="iconfont icon-sousuo"></i>
                                    <span>上架预览</span>
                                </el-button>
                                <el-button size="small" @click="saveDraft()" type="primary" plain>存草稿</el-button>
                                <el-button size="small" @click="submitShow()" type="primary">上 传</el-button>
                            </div>
                        </div>
                    </div>

                </div>
            </el-form>
        </div>
        <ViewDetail v-if="previewFlag && previewData" :previewData="previewData" @back="previewFlag=false"></ViewDetail>

        <el-dialog width="550px" :title="popTitle" :visible.sync="popVisible" :destroy-on-close="true">
            <!-- <SelectTxgl v-if="popTitle=='自定义商品套系'" :type="price_type" @hide="hide"></SelectTxgl>
            <AddTxgl v-if="popTitle=='新增套系'" :form="ruleForm" @hide="hide"></AddTxgl> -->
            <div v-if="popTitle=='温馨提示'">
                <div style="width:80%;margin:0 auto;text-align:center;padding-bottom:20px;">
                    <p style="font-size:16px;color:#292929;">作品发布确认</p>
                    <p style="font-size:14px;color:#808080;">作品发布后，工厂即可在设计超市中浏览和合作，请仔细核对作品详情和分成比例</p>
                </div>
                <div style="text-align:center;border-top:1px solid #ccc;padding-top:25px;">
                    <el-button style="margin-right:20px;" size="small" type="primary" plain @click="submitHide()">再修改一下</el-button>
                    <el-button size="small" type="primary" @click="fchzSubmit">确认并发布</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import _ from 'lodash';
    import { IMG_URL_PRE } from '@/config';
    import store from '@/store';
    import { getCats, getStyles, getSets, getAttrs } from '@/service/item';
    import { uploadFile } from '@/service/common';
    import { addPercentProduct,getBlacklists,designPercentId,setPercentProduct } from '@/service/design';
    import { fetchTree,imgLayout } from '@/util';
    import ViewDetail from '../sjbq/ViewDetail.vue';
    import UploadImgs from '@/components/upload/UploadImgs.vue';
    import UploadImgss from '@/components/upload/UploadImgss.vue';
    import UploadCads from '@/components/upload/UploadCads.vue';
    import DesignSize from '@/components/factory/DesignSize.vue';
    // import SelectTxgl from '@/views/desgin/txgl/SelectTxgl.vue';
    // import AddTxgl from '@/views/desgin/txgl/AddTxgl.vue';

    export default {
        components:{
            UploadImgs,UploadImgss,UploadCads,
            DesignSize,
            // SelectTxgl,AddTxgl,
            ViewDetail
        },
        computed: {
            
        },
        data() {
            var checkPercent = (rule, value, callback) => {
                if (!value) {
                return callback(new Error('请填写分成比例'));
                } else {
                    if (value>100) {
                        return callback(new Error('不能大于100%'));
                    } else if (value<=0) {
                        return callback(new Error('不能小于等于0%'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                imgUrl: IMG_URL_PRE,
                popTitle:null,
                popVisible:false,
                uploadAccept: 'image/jpeg,image/gif,image/png',
                ruleForm: {
                    name: null,
                    sname: null,
                    intro:null,
                    set_no:null,
                    style_no: null,
                    cat_id: null,
                    design_idea:null,
                    price_percent:null,
                    // size: { len: null,wlen: null,height: null, },
                    dimension: [],
                    photo_render:[],
                    photo_cad:[],
                    photo_size:[],
                    photo_story:[],
                    accessory:[],
                    attr: [],
                },
                rules: {
                    name: [{ required: true, message: '填写商品名称', trigger: 'blur' }],
                    // sname: [{ required: true, message: '请填写商品简称', trigger: 'blur' }],
                    // set_no: [{ required: true, message: '请选择套系', trigger: 'blur' }],
                    style_no: [{ required: true, message: '请选择风格', trigger: 'blur' }],
                    cat_id: [{ required: true, message: '请选择类目', trigger: 'blur' }],
                    attr: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value && value.length > 0) {
                                callback();
                            } else if (value && JSON.stringify(value) != '[]') {
                                callback();
                            } else {
                                let _idx = rule.field.split(".")[1];
                                let _name = this.ruleForm.attr[_idx].name;
                                if (!value) {
                                    callback(new Error(`请选择${_name}`));
                                } else {
                                    callback(new Error(`${_name} 至少选择一项!`));
                                }
                            }
                        },
                        trigger: "blur"
                    }],
                    design_idea: [{ required: true, message: '请填写设计理念', trigger: 'blur' }],
                    photo_render: [{ required: true, message: '请上传3D 单品渲染图', trigger: 'blur' }],
                    price_percent: [{validator: checkPercent, trigger: 'blur'}],
                    accessoryName: [{ required: true, message: '请填写附件名称', trigger: 'blur' }],
                    accessoryModuleNo: [{ required: true, message: '请填写型号', trigger: 'blur' }],
                },
                cats: [],
                catList:[],
                styles: [],
                series:[],
                // blacklists:[],
                product_no:null,
                catId:null,
                price_type:1,
                showImgs:false,
                previewFlag:false,
                previewData:null,
            }
        },
        async created() {
            if (this.$route.query.set_no) {
                this.ruleForm.set_no=this.$route.query.set_no;
            }
            this.product_no = this.$route.query.id;
            this.catList = await getCats();
            this.cats = fetchTree(this.catList, null, { name: { dest: 'name' }, id: { dest: 'id' }, parent: 'parentId' });
            this.styles = await getStyles();
            // this.getSeries();
            // this.blacklists = await getBlacklists(store.state.loginUser.user.comp_id,1);
        },
        mounted() {
            if (this.product_no) {
                designPercentId(this.product_no).then(rst => {
                    this.catId = rst.cat.id;
                    if (rst) {
                        this.ruleForm = {
                            name: rst.name,
                            sname: rst.sname,
                            intro:rst.intro,
                            set_no:rst.set_id,
                            style_no: rst.style.id,
                            cat_id: rst.cat.id,
                            design_idea:rst.design_idea,
                            price_percent:Math.floor(rst.price_percent * 100)/10000,
                            // size: rst.size,
                            dimension: rst.dimension,
                            photo_render:rst.photo_render,
                            photo_cad:rst.photo_cad,
                            photo_size:rst.photo_size,
                            photo_story:rst.photo_story,
                            accessory:rst.accessory,
                            attr:rst.attr,
                        };
                        this.get_attrs(this.catId);
                        this.showImgs = true;
                    }
                    console.log(rst);
                }).catch(err => {
                    console.log(err);
                    this.$message.error(err.message);
                });
            } else {
                this.showImgs = true;
            }
        },
        methods: {
            // 选择类目
            handleCat(e) {
                console.log(e);
                this.get_attrs(e);
            },
            // 获取类目下面的spu属性
            get_attrs(catId) {
                getAttrs(catId,{hasValue:true}).then(rst => {
                    rst.forEach(e => {
                        this.$set(e,'values',[]);
                        if (this.ruleForm.attr && this.ruleForm.attr.length>0) {
                            this.ruleForm.attr.forEach((n)=>{
                                if (e.id == n.name) {
                                    if (e.type=='mutil') {
                                        e.values = n.values;
                                    } else e.values = n.values[0];
                                }
                            })
                        }
                    });
                    this.ruleForm.attr = rst;
                    console.log(this.ruleForm.attr);
                }).catch(err => {
                    console.log(err);
                    this.$message.error(err.message);
                });
            },
            back() {
                this.$router.go(-1);
            },
            getSeries() {
                getSets({price_type:this.price_type}).then(rst => {
                    if (rst && rst.length>0) {
                        let series = fetchTree(rst, "", { name: { dest: 'name' }, id: { dest: 'id' }, parent: 'pid' });
                        series.forEach((e)=>{
                            if (e.children && e.children.length>0) {
                                this.series.push(e);
                            }
                        })
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.error(err.message);
                });
            },
            hide(item) {
                this.popVisible = false;
                if (item) {
                    this.getSeries();
                    this.ruleForm.set_no = item.set_no;
                }
            },
            selectSets() {
                this.popTitle = "自定义商品分类";
                this.popVisible = true;
            },
            addSets() {
                this.$router.resolve({
                    path:"/desgin/txgl",
                    query:{idx:this.price_type,}
                })
            },
            // 添加款式
            addAccessory() {
                var obj = { name:null,module_no:'',dimension: [], photo_size:[],photo_story:[] };
                this.ruleForm.accessory.push(obj);
                console.log(this.ruleForm.accessory);
            },
            delAccessory(index) {
                this.$confirm('确认是否删除附件?', '温馨提示', { confirmButtonText: '确定',
                cancelButtonText: '取消', type: 'warning',
                }).then(() => {
                    this.$message({ type: 'success', message: '删除成功!' });
                    this.ruleForm.accessory.splice(index,1);
                });
            },
            preview() {
                this.$refs['ruleForm1'].validate((valid) => {
                    if (valid) {
                        this.previewSubmit();
                    }
                });
            },
            previewSubmit() {
                let _item = _.clone(this.ruleForm);
                _item.price_percent = Math.round(_item.price_percent * 100);
                let setObj=this.series.find((e)=> {
                    return e.set_no == this.ruleForm.set_no;
                })
                let catObj=this.catList.find((e)=> {
                    return e.id == this.ruleForm.cat_id;
                })
                let styleObj=this.styles.find((e)=> {
                    return e.id == this.ruleForm.style_no;
                })
                if (setObj) _item.set_no = setObj.name;
                _item.cat_id = catObj.name;
                _item.style_no = styleObj.name;
                _item.type = 2;// 1版权购买，2分成合作
                this.previewData = _item;
                this.previewFlag = true;
                // this.$router.push({
                //     path:"/desgin/detail/view",
                //     query:{
                //         item:encodeURI(JSON.stringify(_item)),
                //     },
                // })
            },
            checkRuleForm() {
                let attr = [];
                if (this.ruleForm.attr && this.ruleForm.attr.length>0) {
                    this.ruleForm.attr.forEach((e)=>{
                        if (e.type == "single") {
                            attr.push({
                                name: e.id,
                                values: [e.values]
                            })
                        } else if (e.type == "mutil") {
                            attr.push({
                                name: e.id,
                                values: e.values
                            })
                        }
                    })
                }
                return attr;
            },
            // 存草稿
            saveDraft() {
                if (parseInt(this.ruleForm.price_percent)<=0 || parseInt(this.ruleForm.price_percent)>100) {
                    this.$message.error('请输入0%-100%之间的比例');
                } else {
                    const _loading = this.$loading({
                        lock: true,
                        text: '拼命加载中......',
                    });
                    let _item = _.clone(this.ruleForm);
                    _item.attr = this.checkRuleForm();
                    _item.price_percent = Math.round(_item.price_percent * 100);
                    if (!_item.sname) {
                        _item.sname = _item.name;
                    }
                    addPercentProduct(_item).then(rst => {
                        _loading.close();
                        this.$message.success('草稿保存成功');
                        this.back();
                        // this.$router.push('/desgin/fchz');
                    }).catch(err => {
                        _loading.close();
                        this.$message.error(err.message);
                    });
                }
            },
            // 编辑
            editSubmit(publish) {
                if (publish==1 && this.$store.state.loginUser.comp.cert_stat!=2) {
                    this.$message.error("企业未认证");
                    return;
                } else {
                    this.$refs['ruleForm1'].validate((valid) => {
                        if (valid) {
                            let _item = _.clone(this.ruleForm);
                            _item.attr = this.checkRuleForm();
                            _item.price_percent = Math.round(_item.price_percent * 100);
                            _item.publish = publish;
                            if (this.product_no) {
                                _item.product_no = this.product_no;
                                setPercentProduct(_item).then(rst => {
                                    this.$message.success('保存成功');
                                    this.back();
                                    // this.$router.push('/desgin/fchz');
                                }).catch(err => {
                                    this.$message.error(err.message);
                                });
                            }
                        }
                        console.log(valid);
                    });
                }
            },
            submitShow() {
                // console.log(this.$refs['ruleForm1']);
                if (this.$store.state.loginUser.comp.cert_stat!=2) {
                    this.$message.error("企业未认证");
                    return;
                } else {
                    this.$refs['ruleForm1'].validate((valid) => {
                        if (valid) {
                            this.popTitle = "温馨提示";
                            this.popVisible = true;
                        }
                        console.log(valid);
                    });
                }
            },
            submitHide() {
                this.popVisible = false;
            },
            // 发布
            fchzSubmit:_.debounce(function(){
                const _loading = this.$loading({
                    lock: true,
                    text: '拼命加载中......',
                });
                let _item = _.clone(this.ruleForm);
                _item.attr = this.checkRuleForm();
                _item.price_percent = Math.round(_item.price_percent * 100);
                if (!_item.sname) {
                    _item.sname = _item.name;
                }
                _item.publish = 1;
                console.log(_item);
                addPercentProduct(_item).then(rst => {
                    _loading.close();
                    this.$message.success('上传成功');
                    this.submitHide();
                    this.back();
                    // this.$router.push('/desgin/fchz');
                }).catch(err => {
                    _loading.close();
                    this.$message.error(err.message);
                });
            },1000),
        }
    }
</script>
<style>

</style>
<style scoped src="../style.css"></style>
<style scoped lang="less">
    .list-item {
        position:relative;
        padding:30px 0;
        border-bottom:1px solid #E6E6E6;
    }
    .list-item:last-child {
        border-bottom:0;
    }
    .add-accessory {
        height: 70px;
        border-top: 1px solid #E6E6E6;
        >span {
            font-size: 16px;
        }
        .addSeries {
            text-align: center;
            // padding: 10px 90px 0;
            cursor: pointer;
            >span {
                display: inline-block;
                vertical-align: top;
                font-size: 14px;
                color: #016FFF;
                &:first-child {
                    width: 18px;
                    height: 18px;
                    line-height: 15px;
                    text-align: center;
                    font-size: 18px;
                    color: #016FFF;
                    border: 1px solid #016FFF;
                    border-radius: 50%;
                    position: relative;
                    top: 2px;
                    margin-right: 5px;
                }
            }
        }
    }
    .el-input, .el-cascader, .el-select {
        width: 240px;
    }
</style>
<style scoped>
    .shopStyle {
        background: #F5F5F5;
    }
    .shopStyle-item {
        padding: 20px 10px;
        /* border-bottom: 1px solid #CCCCCC; */
    }
    .shopStyle-header {
        padding-left: 10px;
        margin-bottom: 10px;
    }
    .shopStyle-header>div {
        font-size: 14px;
        color: #4D4D4D;
    }
    .shopStyle-header>div:last-child {
        color: #CC995A;
        margin-left: 40px;
        cursor: pointer;
    }
    .ruleDesc {
        /* padding:0 45px; */
        line-height:25px;
        font-size: 14px;
        color: #808080;
    }
    .ruleDesc>div>p {
        margin-bottom: 0;
    }
    .input-red>>> .el-input__inner {
        border: 1px solid #F66F6A;
        padding: 0 0 0 15px;
    }
    .input-red>>> .el-form-item__error {
        left: 270px;
    }
</style>